import { api, ApiError } from "@/lib/api";

export type WecomInboundEvent = {
  id: number;
  msg_type: string | null;
  event_type: string | null;
  change_type: string | null;
  external_userid: string | null;
  from_username: string | null;
  content_text: string | null;
  /** 企微跟进人 UserID（从 XML 抽取） */
  staff_userid?: string | null;
  headline: string;
  raw_xml: string;
  wecom_created_at: string | null;
  created_at: string;
};

export type WecomInboundEventsPayload = {
  inbound_events: WecomInboundEvent[];
  pagination: {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
  matched_contact: boolean;
};

export { ApiError };

export async function listWecomInboundEvents(
  accountId: string | number,
  opts?: { externalUserid?: string; page?: number; perPage?: number },
): Promise<WecomInboundEventsPayload> {
  const params = new URLSearchParams();
  if (opts?.externalUserid) params.set("external_userid", opts.externalUserid);
  if (opts?.page) params.set("page", String(opts.page));
  if (opts?.perPage) params.set("per_page", String(opts.perPage));
  const qs = params.toString();
  return api.fetchForAccount<WecomInboundEventsPayload>(
    accountId,
    `/account/wecom_inbound_events${qs ? `?${qs}` : ""}`,
  );
}
